import { Department } from "./departmentReducer";

export interface ChallengeData {
  name: string;
  aim_statement: string;
  technical_area_id: number;
  department_id: number;
  department: Department;
  effect: string;
  sub_causes: any[];
}

export interface ChallengeState {
  data: ChallengeData[];
  error: string | null;
}

export interface Action {
  type: string;
  payload: any;
}

const initialState: ChallengeState = {
  data: [],
  error: null,
};

export const challengeReducer = (
  state: ChallengeState = initialState,
  action: Action
): ChallengeState => {
  switch (action.type) {
    case "GET_CHALLENGE_SUCCESS":
      return { ...state, data: action.payload };
    case "GET_CHALLENGE_ERROR":
      return { ...state, error: action.payload };
    default:
      return state;
  }
};
